import React, { useCallback, useEffect, useState } from "react";
import { Card, Image, List, Modal, notification, Alert } from "antd";
import { isValidElement, safeStringValue } from "util/ApiHelper";
import { useHistory } from "react-router-dom";
import EnquiryStatusTags from "./EnquiriesStatus";
import { Button } from "antd";
import { tabKeys } from "./EnquiryTabs";
import { CloseOutlined, LeftOutlined, CrownOutlined } from "@ant-design/icons";
import { isLessThan24Hrs } from "util/helper";
import { EnquiryStatus } from "util/Constant";
import {
  isArrayNonEmpty,
  isValidDate,
  isValidString,
} from "../../util/ApiHelper";
import { getNewLine } from "util/helper";
import { useSelector } from "react-redux";
import {
  isCHA,
  isFreightForwarder,
  isManufacturer,
  isShipping,
  isCustomhouseagentsCumFreightforwarder,
} from "../../util/helper";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import UnLockedIcon from "../../../src/assets/images/basil_unlock-solid.svg";
import LockedIcon from "../../../src/assets/images/material-symbols_lock (1).png";

import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { fetchStart, fetchSuccess } from "appRedux/actions/Common";
import { useDispatch } from "react-redux";
import { labelComponent } from "../../util/UtilComponents";
// import SubscriptionPlans from "../subscriptionPlan/subscriptionPlan";
import { updateUserSubscription } from "../../appRedux/actions/authAction";
import { useEnquiryAccess } from "../../hooks/useEnquiryAccess";
import { BUSINESS_TYPE } from "../../util/Constant";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const EnquiryDetails = ({ enquriesData, onNext, enquiryId }) => {
  // const Buyerleads =enquriesData.businessTypes.code==="buyer";
  console.log(
    "enquriesData fron the details",
    enquriesData?.accessInfo?.canAccess
  );


  const EnquiryList = enquriesData?.quotations
  console.log("EnquiryList", EnquiryList)
  const Canaccess = enquriesData?.accessInfo?.canAccess;
  console.log("can", Canaccess);
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();

  const moment = require("moment");
  const userData = useSelector(({ auth }) => auth?.userData);
  const [viewNotification, setViewNotification] = useState(false);
  console.log("viewNotification", viewNotification);

  const [fileName, setFileName] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pointsToDeduct, setPointsToDeduct] = useState(null);
  // const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const ports = useSelector(({ common }) => common.ports);
  const getPortCode = (portName) => {
  if (!portName) return '';
  
  const port = ports.find(p => p.port === portName);
  return port?.code || '';
};

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const role = queryParams.get("role") || "general";
  const authUser = useSelector(({ auth }) => auth.userData);
  const userId = userData?.id;
  console.log("userData details", userData);

    const [userDetails, setUserDetails] = useState(null);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);
    const [subscriptionError, setSubscriptionError] = useState(null);

    const isAdmin = userData?.roles?.name === "admin";
  
    const fetchUserDetails = async () => {
        if (!userId) return;
        
        setSubscriptionLoading(true);
        try {
          const response = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/users/${userId}`
          );
          console.log("User details from API:", response.data);
          setUserDetails(response.data?.data || response.data);
          setSubscriptionStatus(response.data?.data?.Subscription || response.data?.Subscription);
          
         
          
        } catch (err) {
          setSubscriptionError(err.message);
          console.error('User details fetch error:', err);
        } finally {
          setSubscriptionLoading(false);
        }
      };
    
      useEffect(() => {
        if (userId) {
          fetchUserDetails();
        }
      }, [userId]);


        const isFreeUser = subscriptionStatus === 'Free';
        const isPremiumUser = subscriptionStatus === 'Premium' || subscriptionStatus === 'Paid';

  const frieghtforwader = userData?.businessTypes?.code === "freight_forwarder";
  console.log("frieghtforwader", frieghtforwader);
  // const exporter =userData.businessTypes.code==='exporter';
  // const manufacturer =userData.businessTypes.code==='manufacturer';
  // const manufacturercumexporter =userData.businessTypes.code==='manufacturer_exporter';
  // const customhouseagent =userData.businessTypes.code==='custom_house_agent';

  const Otherusers =
    (enquriesData?.accessInfo?.canAccess &&
      userData?.businessTypes?.code === "exporter") ||
    userData?.businessTypes?.code === "manufacturer" ||
    userData?.businessTypes?.code === "commission_agent" ||
    userData?.businessTypes?.code === "custom_house_agent" ||
    userData?.businessTypes?.code === "shipping_line" ||
    userData?.businessTypes?.code === "customhouseagents_freightforwarder" ||
    userData?.businessTypes?.code === "manufacturer_exporter";
  const { isPaidUser, remainingAccess, usedAccess, canAccessEnquiry } =
    useEnquiryAccess();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [limitedView, setLimitedView] = useState(false);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");

  const [userDatas, setUserDatas] = useState(userData);

  const subscription = useSelector(({ user }) => user?.subscription);
  console.log("subscription", subscription);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [error, setError] = useState(null);

  
  // const isFreightForwarder =userData.businessTypes;
  // console.log("isFreightForwarder",isFreightForwarder)
  console.log(
    "EnquiryStatus",
    enquriesData?.quotations[0]?.status === EnquiryStatus.QUOTATION_SENT
  );
  console.log("EnquiryStatus", enquriesData?.user?.id);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
        );
        console.log("Subscription API Response:", response);
        setSubscriptionData(response.data);

        // if (!response.data.isActive) {
        //   setShowSubscriptionPlans(true);
        // }
      } catch (err) {
        setError(err.message);
        console.error("Subscription fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchSubscription();
    }
  }, [userId]);

  console.log(
    "enquriesData check00001",
    enquriesData?.quotations?.[0]?.senderId
  );
  console.log("enquriesData check00001", userData?.id);

  // Add shimmer animation for blur effect
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const styles = {
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      fontSize: "20px",
      fontWeight: "bold",
      background: "#ffffff",
      border: "1px solid #e8e8e8",
      borderRadius: "50%",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      zIndex: 1000,
    },
    blurredText: {
      filter: 'blur(4px)',
      userSelect: 'none',
      background: 'linear-gradient(90deg, #d9d9d9 0%, #f0f0f0 50%, #d9d9d9 100%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
      padding: '2px 8px',
      borderRadius: '4px',
      color: 'transparent',
      textShadow: '0 0 8px rgba(0,0,0,0.3)',
      display: 'inline-block',
      minWidth: '150px'
    }
  };

  const handleCancel = () => {
    history.push("/");
    setIsModalVisible(false);
  };

  const goToProfilePage = () => {
    history.push('/my-profile');
  };




  // Add this function at the top of your component
// Replace your canViewProfile function with this debug version:
const canViewProfile = () => {
  console.log("=== CHECKING VIEW PROFILE ACCESS ===");
  
  // Check if CURRENT USER has sent a quotation
  const currentUserSentQuotation = enquriesData?.quotations?.some(
    quotation => 
      quotation.status === 'quotation_sent' &&
      quotation.senderId === userData?.id
  );
  
  console.log("View Profile check result:", {
    currentUserSentQuotation,
    currentUserId: userData?.id,
    isPremiumUser,
    allQuotations: enquriesData?.quotations?.map(q => ({
      id: q.id,
      status: q.status,
      senderId: q.senderId,
      isCurrentUser: q.senderId === userData?.id
    }))
  });
  
  return currentUserSentQuotation;
};

const displayNotification = useCallback(() => {
    if (!viewNotification) {
      notification.error({
        description:
          "View Profile will be enabled only after Quotation is Sent.",
        style: {
          ...(isMobile && { padding: "10px" }),
        },
      });
      setViewNotification(true);
      setTimeout(() => setViewNotification(false), 5000);
    }
  }, [viewNotification, isMobile]);

  const cargoReadinessDate = moment(enquriesData?.cargoReadinessDate).format(
    "DD-MMM-YYYY"
  );

  const fetchEnquiryStatus = useCallback(async (enquiryId) => {
    console.log("enquiryId", enquiryId);
    if (!enquiryId) return;
    dispatch(fetchStart());
    setLoading(true);
    try {
      const uuid = authUser?.uuid;

      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/unlock-enquiries/${enquiryId}`
      );

      const { constants } = response?.data?.data || {};
      const { enquiry } = response?.data?.data || {};

      const enquiryData = response?.data?.data?.enquiry?.find(
        (item) => item.enquiryId === enquiryId && item.uuid === uuid
      );

      // const PointsData = response?.data?.data?.constants?.find(
      //   (item) => item.key === userData?.businessTypes.code
      // );
      // console.log("responcecheck>>>1Pointsdata", PointsData.value);
      // console.log("responcecheck>>>2Pointsdata", response?.data);

      const PointsData = response?.data?.data?.constants?.find(
        (item) => item.key === userData?.businessTypes?.code
      );
      console.log("responcecheck>>>1Pointsdata", PointsData?.value); // Add optional chaining
      if (PointsData) {
        setPointsToDeduct(PointsData.value);
      } else {
        setPointsToDeduct(null);
      }

      if (enquiryData) {
        setIsUnlocked(enquiryData.status === "unlocked");
      }
      if (PointsData) {
        setPointsToDeduct(PointsData.value);
      } else {
        setIsUnlocked(false);
        setPointsToDeduct(null);
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message || "Failed to fetch enquiry status.",
      });
    } finally {
      setLoading(false);
      dispatch(fetchSuccess());
    }
  }, []);

  // useEffect(() => {
  //   // Check access when component mounts
  //   if (!canAccessEnquiry(enquiryId) && !isPaidUser) {
  //     setLimitedView(true);
  //     setShowUpgradeModal(true);
  //   }
  // }, [enquiryId, canAccessEnquiry, isPaidUser]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchEnquiryStatus(enquiryId);
      setLoading(false);
    };
    if (enquiryId) {
      fetchData();
    }
  }, [enquiryId, fetchEnquiryStatus]);

  const handleUnlock = async () => {
    try {
      setLoading(true);

      const unlockData = {
        usersuuid: userData?.usersuuid,
        enquiryId: enquriesData?.id,
        businessTypes: userData?.businessTypes,
      };

      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/unlock-enquiries`,
        {
          uuid: userData?.uuid,
          enquiryId: enquriesData?.id,
          businessTypes: userData?.businessTypes,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        setIsUnlocked(true);
        notification.success({
          message: "Unlocked Successfully",
          description: "The CompanyName is now visible, and you can proceed.",
        });
      } else {
        notification.error({
          message: "Unlock Failed",
          description:
            response?.data?.message || "Unable to unlock the content.",
        });
      }
    } catch (error) {
      Modal.confirm({
        title: "Insufficient Points",
        content:
          "You don’t have enough points to unlock. Please purchase the required Points.",
        okText: "Purchase Points",
        cancelText: "Cancel",
        onOk: () => {
          history.push("/my-profile");
        },
        onCancel: () => {
          history.push();
        },
      });
    } finally {
      setLoading(false);
    }
  };

  console.log("enquriesData?.id", enquriesData?.id);
  useEffect(() => {
    if (enquriesData?.id) {
      fetchEnquiryStatus(enquriesData.id);
    } else {
      console.error("enquiryId is undefined!");
    }
  }, [enquriesData]);

  useEffect(() => {
    if (isArrayNonEmpty(enquriesData?.productImages)) {
      const fileNames = enquriesData?.productImages?.map((image) => {
        return image;
      });
      setFileName(fileNames);
    }
  }, [enquriesData]);

  // const displayNotification = useCallback(() => {
  //   if (!viewNotification) {
  //     notification.error({
  //       description:
  //         "View Profile will be enabled only after Quotation is Sent to Buyer.",
  //       style: {
  //         ...(isMobile && { padding: "10px" }),
  //       },
  //     });
  //     setViewNotification(true);
  //     setTimeout(() => setViewNotification(false), 5000);
  //   }
  // }, [viewNotification, isMobile]);

  const eventHandler = isMobile
    ? { onClick: displayNotification }
    : { onMouseEnter: displayNotification };

  const getStatus = (record) => {
    let status = record?.readReciept[0]?.status;
    if (!status) {
      status = isLessThan24Hrs(record?.createdAt)
        ? EnquiryStatus.NEW_ENQUIRY
        : EnquiryStatus.AWAITING_FOR_QUOTATION;
    }
  };
  useEffect(() => {
    if (userDatas?.subscription) {
      dispatch(updateUserSubscription(userDatas.subscription));
    }
  }, [userDatas, dispatch]);

  const Buyerleads = enquriesData?.businessTypes?.code === "buyer";

  const hasActiveSubscription = subscriptionData?.isActive;
  console.log("hasActiveSubscription", hasActiveSubscription);

  const isSubscriptionExpired = (subscription) => {
    if (!subscription) return true;

    if (subscriptionData?.isActive === false) return true;
    console.log("subscriptionData", subscriptionData);
    const currentDate = new Date();
    const endDate = new Date(subscription.endDate);
    return endDate < currentDate;
  };
  const handleViewProfile = () => {
    navigateBusinessCard(enquriesData?.user?.id);
  };

  const handleStatusChange = async (newStatus) => {
    try {
      let data = {
        id: id,
        status: newStatus,
      };
      const response = await axiosInstance.post(
        `${BASE_API_CONFIG.baseURL}/enquiries/${id}`,
        data
      );
      
      if (response.status === 200) {
        notification.success({
          message: "Success",
          description: `Rate ${newStatus.toLowerCase()} successfully`,
        });
        history.goBack();
      }
    } catch (error) {
      console.error("Status change error:", error);
      notification.error({
        message: "Error",
        description: `Failed to ${newStatus.toLowerCase()} rate`,
      });
    }
};

  const isSubscribed = [1,2, 3].includes(subscriptionData?.subscription?.planId);

  // const handleViewProfile = () => {
  //   if (!subscriptionData || isSubscriptionExpired(subscriptionData.subscription)) {
  //     setShowSubscriptionPlans(true);
  //   } else {
  //     navigateBusinessCard(enquriesData?.user?.id);
  //   }
  // };

  // const handleCloseSubscriptionPlans = () => {
  //   setShowSubscriptionPlans(false);
  // };

  // Company Name Display Component with Free/Premium logic
  const CompanyNameDisplay = () => {
    const companyName = enquriesData?.user?.companyName || "N/A";
    const userId = enquriesData?.user?.id;
    
    if (isFreeUser) {
      // Free User: Blurred company name with upgrade tag
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
          <span style={styles.blurredText}>
            {companyName}
          </span>
          <span
            onClick={goToProfilePage}
            style={{
              color: "#faad14",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "12px",
              padding: "4px 12px",
              borderRadius: "20px",
              backgroundColor: "#fff7e6",
              border: "1px solid #ffd591",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <CrownOutlined /> UPGRADE TO VIEW PROFILE
          </span>
        </div>
      );
    } else if (isPremiumUser) {
      // Premium User: Full visibility with View Profile link
      return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
          <span style={{ fontWeight: 500 }}>{companyName}</span>
          <span
            onClick={() => {
              if (canViewProfile()) {
                navigateBusinessCard(userId);
              } else {
                displayNotification();
              }
            }}
            style={{
              color: canViewProfile() ? "#1890ff" : "#909090",
              cursor: canViewProfile() ? "pointer" : "not-allowed",
              fontWeight: 500,
              padding: "4px 8px",
              borderRadius: "4px",
              transition: "all 0.2s",
              textDecoration: canViewProfile() ? "underline" : "none"
            }}
          >
            View Profile
          </span>
        </div>
      );
    } else if(isAdmin){
      return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
          <span style={{ fontWeight: 500 }}>{companyName}</span>
          <span
            onClick={() => {
                navigateBusinessCard(userId);
              }
            }
            style={{
              color:"#1890ff",
              cursor: "pointer",
              fontWeight: 500,
              padding: "4px 8px",
              borderRadius: "4px",
              transition: "all 0.2s",
              textDecoration: "underline"
            }}
          >
            View Profile
          </span>
        </div>
      );
    }
    
    // Default case for non-logged in users
    return (
      <div style={{ display: 'flex', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
        <span>{companyName}</span>
        <span
          onClick={() => {
            if (canViewProfile()) {
              navigateBusinessCard(userId);
            } else {
              displayNotification();
            }
          }}
          style={{
            color: canViewProfile() ? "#1890ff" : "#909090",
            cursor: canViewProfile() ? "pointer" : "not-allowed",
            fontWeight: 500
          }}
        >
          View Profile
        </span>
      </div>
    );
  };

  const data = [
    {
      label: "Posted Date",
      value: moment(enquriesData?.createdAt).format("DD-MMM-YYYY"),
    },
    // {
    //   label: "Company Name",
    //   value: (
    //     <>
    //       <div
    //         // style={{
    //         //   position: "relative",
    //         //   filter: isUnlocked ? "none" : "blur(2.3px)",
    //         // }}
    //       >
    //            {enquriesData?.user?.companyName ||isUnlocked } &nbsp;&nbsp;
    //           {  enquriesData?.quotations[1]?.status ===EnquiryStatus.ORDER_CONFIRMED || enquriesData?.quotations[1]?.status ===EnquiryStatus.ORDER_PLACED
    //           || isUnlocked

    //           // (userData?.subscriptionPlan !== "free" )  // Enable for non-free plans

    //           &&  (!frieghtforwader || isUnlocked )   //already correct
    //           && (!exporter || enquriesData?.quotations[0]?.status === EnquiryStatus.QUOTATION_SENT)
    //           && (!manufacturer || enquriesData?.quotations[0]?.status === EnquiryStatus.QUOTATION_SENT)
    //           && (!manufacturercumexporter || enquriesData?.quotations[0]?.status === EnquiryStatus.QUOTATION_SENT)
    //           && (!customhouseagent || enquriesData?.quotations[0]?.status === EnquiryStatus.QUOTATION_SENT)
    //             ? (
    //           <span
    //             onClick={() => navigateBusinessCard(enquriesData?.user?.id)}
    //             // onClick={handleViewProfile}
    //             className={"myexim-link "}
    //           >
    //             View Profile
    //           </span>
    //         ) : (
    //           <span
    //             style={{
    //               color: "#909090",
    //               cursor: "Pointer",
    //               maxWidth: "80px",
    //             }}
    //             {...eventHandler}
    //             // onClick={() => setShowSubscriptionPlans(true)}
    //             className={"myexim-link "}
    //           >
    //             View Profile
    //           </span>
    //         )}
    //       </div>
    //       {/* {!isUnlocked && (
    //         <> */}
    //           {/* <Button
    //             style={{
    //               background: "#84D073",
    //               borderRadius: "16.15px",
    //               height: "24px",
    //               width: "270px",
    //               display: "flex",
    //               alignItems: "center",
    //               justifyContent: "center",
    //             }}
    //             onClick={handleUnlock}
    //             loading={loading}
    //           >
    //             <div style={{ display: "flex" }}>
    //               <div>
    //                 <img
    //                   src={UnLockedIcon}
    //                   alt="Locked Icon"
    //                   style={{ width: "16px", marginRight: "16px" }}
    //                 />
    //               </div>
    //               <div style={{color: "white" }}>unlock to view the company name</div>
    //             </div>
    //           </Button> */}
    //           {/* <p style={{ color: "#434E5B" }}>
    //             {`Use ${pointsToDeduct || ""} point${
    //               pointsToDeduct !== 1 ? "s" : ""
    //             } to unlock`}
    //           </p>
    //         </>
    //       )} */}
    //     </>
    //   ),
    // },
   {
  label: "Company Name",
  value: <CompanyNameDisplay />,
},
    ...(!isCHA(userData) &&
    !isShipping(userData) &&
    !isFreightForwarder(userData)
      ? [
          {
            label: "Category",
            value: enquriesData?.categories?.name,
          },
        ]
      : []),

    ...(!isCHA(userData) &&
    !isShipping(userData) &&
    !isFreightForwarder(userData) &&
    role !== BUSINESS_TYPE.FREIGHT_FORWARDER
      ? [
          {
            label: "HS Code / Item Description",
            value: enquriesData?.hscode
              ? `${enquriesData.hscode.code} - ${enquriesData.hscode.description}`
              : "N/A",
          },
        ]
      : []),
    {
      label: "Product Name",
      value: enquriesData?.productName,
    },
    {
      label: "Quantity",
      value: `${
        enquriesData?.qty
          ? enquriesData?.qty + " " + enquriesData?.units
          : enquriesData?.noOfContainers +
            " " +
            (enquriesData?.noOfContainers > 1 ? "Containers" : "Container")
      }`,
    },

     ...(isValidElement(enquriesData?.negotiatePricePerUnit)
          ? [
              {
                label: "Negotiate Price Per Unit",
                value: `${enquriesData?.negotiatePricePerUnit} / ${enquriesData?.units} `,
              },
            ]
          : []),

    ...(isManufacturer(userData)
      ? [
          {
            label: "Delivery Terms",
            value: `${safeStringValue(
              enquriesData?.paymentTerms
            )} - ${safeStringValue(enquriesData?.locationForDelivery)}`,
          },
        ]
      : []),
    ...(enquriesData?.netWeightPerContainer
      ? [
          {
            label: "Net Weight Per Container",
            value: `${enquriesData?.netWeightPerContainer} Killograms`,
          },
        ]
      : []),
    {
      label: "Source Country",
      value: enquriesData?.sourceCountry,
    },
    ...(isCHA(userData) ||
    isShipping(userData) ||
    isFreightForwarder(userData) ||
    isCustomhouseagentsCumFreightforwarder(userData)
      ? [{ label: "Container Type", value: enquriesData?.containerType }]
      : []),

    ...(isCHA(userData) || isShipping(userData) || isFreightForwarder(userData)
      ? [
          {
            label: "Loading Port",
            value: `${enquriesData?.sourcePort} (${getPortCode(
              enquriesData?.sourcePort
            )})`,
          },
        ]
      : []),
    {
      label: "Destination Country",
      value: enquriesData?.destinationCountry,
    },
    ...(enquriesData?.destinationPort
      ? [
          {
            label: "Destination Port",
            value: `${enquriesData?.destinationPort} (${getPortCode(
              enquriesData?.destinationPort
            )})`,
          },
        ]
      : []),
    ...(enquriesData?.deliveryLocation
      ? [
          {
            label: "Delivery Location",
            value: enquriesData?.deliveryLocation
          },
        ]
      : []),
    ...(enquriesData?.expectedLoadingDate
      ? [
          {
            label: "Expected Loading Date",
            value: moment(enquriesData?.expectedLoadingDate).format("DD-MMM-YYYY"),
          },
        ]
      : []),
    {
      label: "Requirement Details",
      value: getNewLine(enquriesData?.description),
    },
    {
      label: "Status",
      value: getStatus(enquriesData),
    },
    ...(enquriesData?.rateindication
      ? [
          {
            label: "Rate Indication",
            value:`${enquriesData?.rateindication} ${enquriesData?.currency}`,
          },
        ]
      : []),
    ...(isValidDate(cargoReadinessDate)
      ? [
          {
            label: "Cargo Readiness Date",
            value: moment(enquriesData?.cargoReadinessDate).format(
              "DD-MMM-YYYY"
            ),
          },
        ]
      : []),

    //   ...(isFreightForwarder(userData)
    //   ? [
    //   {
    //     label:labelComponent('Note:'),
    //     value:"You can still send the quotation without Subscription. We will coordinate with the exporter and get back to you."
    //   }
    // ]
    // : []),
  ];

  const navigateBusinessCard = (id) => {
    // const id=enquriesData?.userId;
    if (id) {
      history.push(`/user-profile?id=${id}`);
    }
    console.log("Id", enquriesData?.userId);
  };

  const tabScreen = window.innerWidth >= 992 && window.innerWidth <= 1114

  return (
    isValidElement(enquriesData) && (
      <>
        <Card className="myexim-detail-card">
          <div className="myexim-table-title">
            <LeftOutlined
              // className={"back-icon"}
              style={{ fontSize: "20px", color: '#434E5B'}}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
            Enquiry Details
          </div>
          {isFreightForwarder(userData) && (
            <Alert
              className="gx-mt-3"
              type="info"
              showIcon
              message="Company details notice"
              description="Company details and View Profile will be shown on the next Prepare Quotation page."
            />
          )}
          {!isUnlocked && (
            <>
              <div
                style={{
                  alignContent: "right",
                  alignItems: "right",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {/* <Button
                style={{
                  background: "#F8900E",
                  borderRadius: "16.15px",
                  height: "24px",
                  width: "95px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                loading={loading}
              > */}
                {/* <div style={{ display: "flex" }}>
                  <div>
                    <img
                      src={LockedIcon}
                      alt="Locked Icon"
                      style={{ width: "16px", marginRight: "16px" }}
                    />
                  </div>
                  <div style={{ color: "white" }}>locked</div>
                </div> */}
                {/* </Button> */}
              </div>
            </>
          )}
          <List
            className="gx-mt-4"
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item) =>
              item?.value && (
                <List.Item className="myexim-details-list">
                  <List.Item.Meta
                    title={<div>{item.label}</div>}
                    description={<div>{item.value}</div>}
                  />
                </List.Item>
              )
            }
          />
          {fileName?.length > 0 && (
            <div className="attachments gx-mt-3">
              <div className="sub-header">Attachments</div>
              <div>
                Please find the below attachment as a reference to the
                requirement
              </div>
              <div className="gx-pt-4">
                {fileName?.map((fileName, index) => (
                  <div key={index} className="gx-pb-3">
                    <Image
                      className="gx-rounded-lg"
                      width={isMobile ? "100%" : 150}
                      height={isMobile ? "100%" : 150}
                      src={fileName?.src}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          {
            (enquriesData.status === "Submitted")
            ?
            <div
            style={{
              justifyContent: isMobile ? "center" : tabScreen ? "center" : "end",
              display: "flex",
              flex: 1,
              flexWrap: "wrap",
              alignItems: "center",
              marginRight: 0,
            }}
            // className="gx-pt-4"
          >
            <Button
              type="secondary"
              size="large"
              className="submit-btn"
              onClick={() => {
                handleStatusChange("Rejected");
              }}
              style={{
                marginRight: isMobile ? 0 : tabScreen ? 0 :  ""
              }}
            >
              Reject
            </Button>
            <Button
              type="primary"
              size="large"
              className="submit-btn"
              disabled={!Canaccess}
              onClick={() => {
                handleStatusChange("Confirmed");
              }}
            >
              Confirm
            </Button>
          </div>
              : enquriesData.status === "Confirmed" || enquriesData.status === "Rejected" ? (
                   <>
                   </>
                ) 
              : 
          <div
            style={{
              justifyContent: isMobile ? "center" : tabScreen ? "center" : "end",
              display: "flex",
              flex: 1,
              flexWrap: "wrap",
              alignItems: "center",
              marginRight: 0,
            }}
            // className="gx-pt-4"
          >
            <Button
              type="secondary"
              size="large"
              className="submit-btn"
              onClick={() => {
                history.goBack();
              }}
              style={{
                marginRight: isMobile ? 0 : tabScreen ? 0 :  ""
              }}
            >
              Cancel
            </Button>
            <Button
            type="primary"
            size="large"
            className="submit-btn"
            onClick={() => {
              onNext(tabKeys.QUOTATION_TAB);
            }}
          >
            {isArrayNonEmpty(enquriesData.quotations) &&
            enquriesData?.quotations?.[0]?.senderId === userData?.id
              ? "View Quotation"
              : "Prepare Quotation"}
          </Button>
          </div>
          }
        </Card>
{/* 
        <Modal
          visible={showSubscriptionPlans}
          onCancel={handleCloseSubscriptionPlans}
          closeIcon={<CloseOutlined style={styles.closeButton} />}
          footer={null}
          width={800}
        >
          <SubscriptionPlans
            userDatas={userDatas}
            setUserDatas={setUserDatas}
          />
        </Modal> */}
      </>
    )
  );
};

export default EnquiryDetails;
